var path = 'areas/projects/actions/azure_service_fabric_powershell/Octopus.AzureServiceFabricPowerShell_summary.html';
var html = "<p> Run a PowerShell script using an Azure Service Fabric cluster context <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_service_fabric_powershell/Octopus.AzureServiceFabricPowerShell_summary.html
// module id = 4289608351358209
// module chunks = 1